import { useLocation, useParams } from "react-router-dom";
import { API_PATHS } from "@/constants";
import { useLoadQuizBlocks } from "@/hooks/useLoadQuizBlocks";
import { QuizContextProvider } from "@/pages/quiz/context";
import FullScreenLoader from "@/components/FullScreenLoader";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { CookiesKey } from "@/types/cookies";
import { requestParams } from "@/utils/requestParams";
import { QuizIDs } from "@/pages/quiz/context/common";
import { QuizV1 } from "@/pages/quiz/base";
import React from "react";

import "@/pages/quiz/styles.css";

import { QuizV4 } from "@/pages/quiz/15000";
import { Helmet } from "react-helmet-async";

const QuizPageContainer = () => {
  const { quizId } = useParams();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const { loading, quizBlocks } = useLoadQuizBlocks(
    quizId ? API_PATHS.QUIZ_BLOCKS(quizId) : null
  );

  useEffect(() => {
    if (quizId === QuizIDs["12000"]) {
      window.location.replace(`${import.meta.env.VITE_FRONT_BASE_URL}/intake`);
    }
  }, [quizId]);

  useEffect(() => {
    if (search.length) {
      try {
        Cookies.set(CookiesKey.EV_ENTRY_PARAMS, encodeURIComponent(search));
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  useEffect(() => {
    try {
      requestParams.forEach((param) => {
        const value = searchParams.get(param);
        if (value !== null && value !== "") {
          Cookies.set(param, value, {
            domain: ".skinnyrx.com",
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
  }, [searchParams]);

  const quizV4 = QuizIDs["15000"] === quizId;

  let QuizComponent = QuizV1;

  if (quizV4) QuizComponent = QuizV4;

  if (loading || !quizId) {
    return <FullScreenLoader isLoading={loading} />;
  }

  return (
    <QuizContextProvider
      isCommerce={!!searchParams.get("commerce")}
      questions={quizBlocks}
      quizId={quizId}
      isSubmitOnLastAnswer
    >
      <>
        <Helmet>
          <link
            rel="canonical"
            href={`${window.location.origin}/quiz/${quizId}`}
          />
        </Helmet>

        <QuizComponent quizId={quizId} />
      </>
    </QuizContextProvider>
  );
};

export default QuizPageContainer;
